export default class Countdown {
    constructor({ timeStamp, refreshTime }) {
        this.timeStamp = timeStamp;
        this.refreshTime = refreshTime;
        this.remainingTime = timeStamp - new Date().getTime();
    }

    updateCountdown(timeStamp) {
        this.timeStamp = timeStamp;
        this.remainingTime = timeStamp - new Date().getTime();
    }

    timeEnd() {
        const { days, hours, minutes, seconds } = this.remainingTimeObject();
        return (parseInt(days) + parseInt(hours) + parseInt(minutes) + parseInt(seconds)) <= 0;
    }

    remainingTimeObject() {
        return this.transformTimeStamp(this.remainingTime);
    }

    decrement() {
        this.remainingTime -= this.refreshTime;
    }

    transformTimeStamp(time) {
        if(time < 0) {
            return {
                days: '00',
                hours: '00',
                minutes: '00',
                seconds: '00',
            };
        
        }
        let seconds = Math.floor(time / 1000);
        let minute = Math.floor(seconds / 60);
        seconds = seconds % 60;
        let hour = Math.floor(minute / 60);
        minute = minute % 60;
        const days = Math.floor(hour / 24);
        hour = hour % 24;

        return {
            days: days < 10 ? `0${days}` : days.toString(),
            hours: hour < 10 ? `0${hour}` : hour.toString(),
            minutes: minute < 10 ? `0${minute}` : minute.toString(),
            seconds: seconds < 10 ? `0${seconds}` : seconds.toString()
        };
    }
}
